import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Grid, Typography } from "@material-ui/core";
import {
  getMedicamentosPermitidosDeEmpadronamiento,
  postMedicamentosMedicacion,
  replaceMedicamentosPorSeleccionados
} from "../../../actions/empadronamiento/Empadronamiento";
import { MedicacionAddMedicamento } from "./MedicacionAddMedicamento";
import { MedicacionMedicamento } from "./MedicacionMedicamento";
import AlertaMedicamento from "../UI/AlertaMedicamento";
import { validarSoloUnPermiso } from "../../../helpers/permisos";
import { MEDICACION_MENU_PERMISOS } from "../../../utils/permisos";
import { EMPADRONAMIENTO_MEDICACION_ESTADOS } from "../../../utils/constants";
//import { Redirect } from "react-router-dom";

export const MedicacionMedicamentosModalGestionar = (props) => {
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const [mensaje, setMensaje] = useState("");
  const [medicamentosModificados, setMedicamentosModificados] = useState(false);
  const [actualizarEmpadronamiento, setActualizarEmpadronamiento] = useState(false);
  const { medicamentos = [], solicitudSeleccionada = {}, medicamentosDeEmpadronamiento = [] } = useSelector(
    (state) => state.empadronamiento
  );
  const { permisos: permisosUser } = useSelector(
    (state) => state.auth
  );


  useEffect(() => {
    dispatch(replaceMedicamentosPorSeleccionados(solicitudSeleccionada?.medicamentos));
  }, []);

  useEffect(() => {
    dispatch(getMedicamentosPermitidosDeEmpadronamiento(solicitudSeleccionada?.idSolicitudEmp));
  }, [solicitudSeleccionada]);

  const onConfirmHandler = () => {
    const medicamentosFormateados = medicamentos.map((medicamento) => {
      return {
        idSolicitud: solicitudSeleccionada.idSolicitud,
        idMedicamento: medicamento.idMedicamento,
        cantidad: medicamento.cantidad,
        dosis: medicamento.dosis,
        posologia: medicamento.posologia,
        surge: medicamento.surge,
        idConvenioSC: medicamento.idConvenioSC,
        idTipoEmpadronamiento: solicitudSeleccionada.idTipoEmpadronamiento,
      };
    });

    dispatch(postMedicamentosMedicacion({ medicamentos: medicamentosFormateados, medicamentosModificados, actualizarEmpadronamiento }, false, setOpen));
  };

  const onClickSiguienteHandler = () => {
    var medicamentosValidos = true;
    var mensajeString = "";
    var drogas = "";
    setMensaje("");
    setMedicamentosModificados(false);

    const medicamentosFormateados = medicamentos.map((medicamento) => {
      return {
        idSolicitud: solicitudSeleccionada.idSolicitud,
        idMedicamento: medicamento.idMedicamento,
        cantidad: medicamento.cantidad,
        dosis: medicamento.dosis,
        posologia: medicamento.posologia,
        surge: medicamento.surge,
        idConvenioSC: medicamento.idConvenioSC,
        idTipoEmpadronamiento: solicitudSeleccionada.idTipoEmpadronamiento,
        medicamento: medicamento.medicamento
      };
    });

    //Busco medicamentos de mas
    medicamentosFormateados.forEach(medicamento => {
      if (medicamentosDeEmpadronamiento.filter(item => item.idMedicamento === medicamento.idMedicamento).length === 0) {
        medicamentosValidos = false;
        if (medicamento?.medicamento?.drogas.length > 40) {
          drogas = medicamento?.medicamento?.drogas.substring(0, 40) + "[...]";
        } else {
          drogas = medicamento?.medicamento?.drogas;
        }

        if (mensajeString !== "") {
          mensajeString = `${mensajeString}.\n El medicamento ${medicamento.medicamento?.presentacion} | ${medicamento.medicamento?.laboratorio} | ${medicamento?.medicamento?.nombre} | ${drogas}, no se encuentra originalmente en el empadronamiento.\n`;
        } else {
          mensajeString = "El medicamento " + medicamento.medicamento?.presentacion + " | " + medicamento.medicamento?.laboratorio + " | " + medicamento?.medicamento?.nombre + " | " + drogas + ", no se encuentra originalmente en el empadronamiento.\n";
        }
      }
    });    

    //Despues busco medicamentos de menos
    medicamentosDeEmpadronamiento.forEach(medicamento => {
      if (medicamentosFormateados.filter(item => item.idMedicamento === medicamento.idMedicamento).length === 0) {
        medicamentosValidos = false;
        if (medicamento?.medicamento?.drogas.length > 40) {
          drogas = medicamento?.medicamento?.drogas.substring(0, 40) + "[...]";
        } else {
          drogas = medicamento?.medicamento?.drogas;
        }

        if (mensajeString !== "") {
          mensajeString = `${mensajeString}\n El medicamento ${medicamento.medicamento?.nombre} | ${medicamento.medicamento?.laboratorio} | ${drogas} | ${medicamento?.medicamento?.presentacion}, se encuentra originalmente en el empadronamiento y ha sido eliminado de esta receta.\n`;
        } else {
          mensajeString = "El medicamento " + medicamento.medicamento?.nombre + " | " + medicamento.medicamento?.laboratorio + " | " + drogas + " | " + medicamento?.medicamento?.presentacion + ", se encuentra originalmente en el empadronamiento y ha sido eliminado de esta receta.\n";
        }
      }
    });

    //validar
    if (medicamentosValidos) {
      dispatch(postMedicamentosMedicacion({ medicamentos: medicamentosFormateados, medicamentosModificados, actualizarEmpadronamiento }, false, setOpen));
    } else {
      setMedicamentosModificados(true);
      setMensaje(mensajeString + " ¿Desea continuar?");
      setOpen(true);
    }
  };

  const esCarga = !validarSoloUnPermiso(
    permisosUser,
    MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA
  ) && !validarSoloUnPermiso(
    permisosUser,
    MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_EXT
  );

  /*
  const esOspe = validarSoloUnPermiso(
    permisosUser,
    MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA
  ) && !validarSoloUnPermiso(
    permisosUser,
    MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_EXT
  );
  */

  const esCeiba = !validarSoloUnPermiso(
    permisosUser,
    MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA
  ) && validarSoloUnPermiso(
    permisosUser,
    MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA_EXT
  );

  const disabledEnGestionar = esCarga ||
    solicitudSeleccionada?.idEstadoSolicitud === EMPADRONAMIENTO_MEDICACION_ESTADOS.PENDIENTE_AUTORIZACION ||
    solicitudSeleccionada?.idEstadoSolicitud === EMPADRONAMIENTO_MEDICACION_ESTADOS.AUTORIZADA ||
    solicitudSeleccionada?.idEstadoSolicitud === EMPADRONAMIENTO_MEDICACION_ESTADOS.RECHAZADA ||
    (solicitudSeleccionada?.idEstadoSolicitud === EMPADRONAMIENTO_MEDICACION_ESTADOS.PENDIENTE_REVISION && esCeiba);

  const parsearNumero = (valor) => {
    if (!valor) return 0;
    const numero = parseFloat(valor.toString().replace(",", "."));
    return isNaN(numero) ? 0 : numero;
  };
  const sumaTotal = medicamentos.reduce((acumulado, medicamento) => {
    return acumulado + parsearNumero(medicamento.precioSeleccionado);
  }, 0);

  const totalFormateado = new Intl.NumberFormat("es-AR", {
    style: "currency",
    currency: "ARS",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(sumaTotal);
  return (
    <>
      {(solicitudSeleccionada?.idEstadoSolicitud !== EMPADRONAMIENTO_MEDICACION_ESTADOS.AUTORIZADA &&
        solicitudSeleccionada?.idEstadoSolicitud !== EMPADRONAMIENTO_MEDICACION_ESTADOS.RECHAZADA
      ) &&
        <MedicacionAddMedicamento desdeIngreso={false} disabledEnGestionar={disabledEnGestionar} />}
      {medicamentos
        .filter((medicamento) => medicamento.fechaBaja == null)
        .map((medicamento, index) => {
          return (
            <MedicacionMedicamento
              key={index}
              medicamento={medicamento}
              idTipoEmpadronamiento={solicitudSeleccionada?.empadronamientoSolicitud?.idTipoEmpadronamiento}
              desdeIngreso={false}
              disabledEnGestionar={disabledEnGestionar}
            />
          );
        })}
      <Grid item style={{ textAlign: 'center' }}>
        <Typography style={{ fontWeight: 'bold' }}>TOTAL: {totalFormateado}</Typography>
      </Grid>
      <div
        style={{ display: "flex", justifyContent: "center", margin: "2rem" }}
      >
        <Button
          variant="contained"
          color="primary"
          onClick={onClickSiguienteHandler}
          disabled={disabledEnGestionar}
        >
          Guardar Cambios
        </Button>
      </div>
      {true
        &&
        <AlertaMedicamento
          open={open}
          setOpen={setOpen}
          mensaje={mensaje}
          handleDecisionYes={onConfirmHandler}
          handleDecisionNo={false}
          actualizarEmpadronamiento={actualizarEmpadronamiento}
          setActualizarEmpadronamiento={setActualizarEmpadronamiento}
        />}
    </>
  );
};
